/* global angular */

var ngModule = angular.module('trends');

ngModule.directive('mainTitle',
    function () {
        return {
            restrict: 'A',
            scope: false,
            link: function (scope, element, attrs) {
                document.title = attrs.mainTitle;
            }
        };
    }
);
